import React, { Component } from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import {
  Login,
  ResetPassword,
  Calendar,
  Room,
  DetailRoom,
  Sidebar,
  Booking,
  TimelineRoom,
  FloorPlan,
  UserSetting,
  Thankyou,
  BookingDetail,
} from './containers'
import {
  ROUTE,
  TEXT_ENCRYPT,
  getLocalStorage,
  getSessionStorage,
  removeLocalStorage,
  removeSessionStorage,
  setLocalStorage,
  setSessionStorage,
} from './helpers'
import './App.css'
import { bindActionCreators } from 'redux'
import { ACCOUNT, SETTING } from './reduxs'
import { connect } from 'react-redux'
import moment from 'moment'
import {
  initFirebase,
  unregisterServiceWorker
} from './configs'

const routerStyle = {
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  position: 'relative',
}

export class RouterPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      serviceWorkerRegistration: null,
      isSelectedToday: false,
    }
  }
  
  setStateRegistration = (serviceWorkerRegistration) => {
    this.setState({ serviceWorkerRegistration })
  }

  checkquery = (props) => {
    const query = props.location.search.slice(1);
    const object = {};
    for (let param of query.split("&")) {
      const qwe = param.split("=");
      if (qwe[0]) {
        object[decodeURIComponent(qwe[0])] = qwe[1] ? decodeURIComponent(qwe[1]) : "";
      }
    }
    return object;
  };

  checkSection = (history) => {
    const { accountReducer } = this.props;
    if (accountReducer.user.username === "") {
      const { accountAction } = this.props;
      const user = getLocalStorage(TEXT_ENCRYPT.ACCOUNT) || getSessionStorage(TEXT_ENCRYPT.ACCOUNT)
      const pass = getLocalStorage(TEXT_ENCRYPT.PASS) || getSessionStorage(TEXT_ENCRYPT.PASS)
      const session = getLocalStorage(TEXT_ENCRYPT.ACCESS_TOKEN) || getSessionStorage(TEXT_ENCRYPT.ACCESS_TOKEN)
      if (session) {
        accountAction.getSessionLogin(session,history)
      }
      else if (session !== null && user !== null && pass !== null) {
        accountAction.loginUser(
          {
            username: user
              .replace(TEXT_ENCRYPT.ACCOUNT, "")
              .replace(TEXT_ENCRYPT.ACCOUNT, ""),
            password: pass
              .replace(TEXT_ENCRYPT.PASS, "")
              .replace(TEXT_ENCRYPT.PASS, ""),
          },
          history,
        );
      } else {
        history.push(ROUTE.LOGIN.LINK);
      }
    }
  };

  checkParam = (props) => {
    const { location } = props;
    let history = this.history(props.history);
    let objDate = {};
    let displayDate = "";
    if (
      location.pathname === ROUTE.MEETING_ROOM.LIST ||
      location.pathname.includes(ROUTE.MEETING_ROOM.DETAIL) ||
      location.pathname === ROUTE.USER_SETTING.LINK ||
      location.pathname.startsWith(ROUTE.BOOKING.LINK) ||
      location.pathname.startsWith('/meeting-info')
    ) {
      let queryObj = this.checkquery(props);
      if (queryObj.date) {
        let date = queryObj.date;
        const time = new Date();
        displayDate = new Date(date);
        if (!isNaN(displayDate.getTime())) {
          displayDate.setHours(time.getHours());
          displayDate.setMinutes(time.getMinutes());
          objDate = {
            date: displayDate.getDate(),
            month: displayDate.getMonth() + 1,
            year: displayDate.getFullYear(),
          };
        } else {
          displayDate = time;
          objDate = {
            date: displayDate.getDate(),
            month: displayDate.getMonth() + 1,
            year: displayDate.getFullYear(),
          };
        }
      } else {
        displayDate = new Date();
        objDate = {
          date: displayDate.getDate(),
          month: displayDate.getMonth() + 1,
          year: displayDate.getFullYear(),
        };
        history.push(
          `${location.pathname}?date=${moment(displayDate).format(
            "YYYY-MM-DD"
          )}`
        );
      }
    } else {
      let date = props.match.params.date;
      let month = props.match.params.month;
      let year = props.match.params.year;
      let view = props.match.params.view;

      date =
        parseInt(date) > 0 && parseInt(date) <= 31
          ? parseInt(date)
          : new Date().getDate();
      month =
        parseInt(month) > 0 && parseInt(month) <= 12
          ? parseInt(month)
          : new Date().getMonth() + 1;
      year =
        parseInt(year) > 99 && parseInt(year) < 4000
          ? parseInt(year)
          : new Date().getFullYear();
      if (
        view !== "year" &&
        view !== "month" &&
        view !== "week" &&
        view !== "day"
      ) {
        view = "month";
      }
      displayDate = new Date(year, month - 1, date);
      objDate = { date, month, year, view };
    }

    return { objDate, displayDate };
  };

  history = (history) => {
    return {
      ...history,
      push: (path) => {
        if (!path.includes(ROUTE.BOOKING.LINK)) {
          setLocalStorage("path", path);
        }
        history.push(path);
      },
    };
  };

  startFirebase = async () => {
    const isUsernameLogin = (
      getSessionStorage(TEXT_ENCRYPT.ACCESS_TOKEN) ||
      getLocalStorage(TEXT_ENCRYPT.ACCESS_TOKEN)
    )

    const isRegisterFirebase = getSessionStorage(TEXT_ENCRYPT.IS_REGISTER_FIREBASE)

    if (isUsernameLogin && !isRegisterFirebase) {
      setSessionStorage(TEXT_ENCRYPT.IS_REGISTER_FIREBASE, 'registered')
      setLocalStorage(TEXT_ENCRYPT.IS_REGISTER_FIREBASE, 'registered')

      const FCMResponse = await initFirebase()

      if (FCMResponse.status) {
        removeLocalStorage(TEXT_ENCRYPT.IS_REGISTER_FIREBASE)
        removeSessionStorage(TEXT_ENCRYPT.IS_REGISTER_FIREBASE)
        removeLocalStorage(TEXT_ENCRYPT.IS_LOGIN)
        removeSessionStorage(TEXT_ENCRYPT.IS_LOGIN)
      }
    }
  }

  async componentDidMount() {
    await initFirebase()
    window.addEventListener('beforeunload', unregisterServiceWorker)
  }

  async componentDidUpdate () {
    if (getSessionStorage(TEXT_ENCRYPT.IS_LOGIN) || getLocalStorage(TEXT_ENCRYPT.IS_LOGIN)) {
      try{
        await this.startFirebase()
      }catch{
        console.error('startFirebase error')
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', unregisterServiceWorker)
  }

  setSelectedToday = (isSelectedToday) => {
    this.setState({ isSelectedToday })
  }

  redirectPageBlank = () => {
    if(window.location.pathname !== ROUTE.ROUTE_MS_LOGIN_LANDING_PAGE.LINK) {
      return <Redirect
      to={`${ROUTE.CALENDAR.LINK}/month/${new Date().getFullYear()}/${
        new Date().getMonth() + 1
      }/${new Date().getDate()}`}
    />
    }
  }

  render() {
    const { isSelectedToday } = this.state
    const { accountReducer, settingReducer } = this.props
    const { colorTheme } = settingReducer.settingTheme

    return (
      <BrowserRouter basename={process.env.REACT_APP_PUBLIC_URL}>
        <Switch>
          <Route
            path={`${ROUTE.BOOKING.LINK}/:bookingId?`}
            render={(props) => {
              let objDate = this.checkParam(props).objDate;
              this.checkSection(props.history);
              return (
                <div style={routerStyle}>
                  {colorTheme && (
                    <Sidebar
                      {...props}
                      {...objDate}
                      history={this.history(props.history)}
                      checkSection={this.checkSection}
                    />
                  )}
                  {accountReducer.user.username &&
                  colorTheme && (
                    <Booking
                      params={props.match.params}
                      query={this.checkquery(props)}
                      {...props}
                      history={this.history(props.history)}
                    />
                  )}
                </div>
              );
            }}
          />

          <Route
            path={`${ROUTE.MEETING_ROOM.LIST}`}
            render={(props) => {
              let objDate = this.checkParam(props).objDate;
              let displayDate = this.checkParam(props).displayDate;
              this.checkSection(props.history);
              return (
                <div style={routerStyle}>
                  {colorTheme && (
                    <Sidebar
                      {...props}
                      {...objDate}
                      history={this.history(props.history)}
                      checkSection={this.checkSection}
                    />
                  )}
                  {accountReducer.user.username && colorTheme && (
                    <Room
                      {...props}
                      history={this.history(props.history)}
                      displayDate={displayDate}
                    />
                  )}
                </div>
              );
            }}
          />

          <Route
            path={`${ROUTE.MEETING_ROOM.DETAIL}/:id`}
            render={(props) => {
              let objDate = this.checkParam(props).objDate;
              let displayDate = this.checkParam(props).displayDate;
              this.checkSection(props.history);
              return (
                <div style={routerStyle}>
                  {colorTheme && (
                    <Sidebar
                      {...props}
                      {...objDate}
                      history={this.history(props.history)}
                    />
                  )}
                  {accountReducer.user.username && colorTheme && (
                    <DetailRoom
                      displayDate={displayDate}
                      history={this.history(props.history)}
                      {...props}
                    />
                  )}
                </div>
              );
            }}
          />

          <Route
            path={`${ROUTE.FLOORPLAN.CALENDAR}/:roomId/:year/:month/:date`}
            render={(props) => {
              let objDate = this.checkParam(props).objDate;
              let displayDate = this.checkParam(props).displayDate;
              this.checkSection(props.history);
              return (
                <div style={routerStyle}>
                  {colorTheme && (
                    <Sidebar
                      {...props}
                      {...objDate}
                      history={this.history(props.history)}
                    />
                  )}
                  {accountReducer.user.username && colorTheme && (
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        flexDirection: "column",
                      }}
                    >
                      <TimelineRoom
                        displayDate={displayDate}
                        params={props.match.params}
                        query={this.checkquery(props)}
                        history={this.history(props.history)}
                        headerType="close"
                        colorTheme={colorTheme}
                        isFloorPlan={true}
                      />
                    </div>
                  )}
                </div>
              );
            }}
          />

          <Route
            path={`${ROUTE.FLOORPLAN.LINK}/:year/:month/:date`}
            render={(props) => {
              let objDate = this.checkParam(props).objDate;
              // let displayDate = this.checkParam(props).displayDate
              this.checkSection(props.history);
              return (
                <div style={routerStyle}>
                  {colorTheme && (
                    <Sidebar
                      {...props}
                      {...objDate}
                      history={this.history(props.history)}
                    />
                  )}
                  {accountReducer.user.username && colorTheme && (
                    <FloorPlan
                      params={props.match.params}
                      query={this.checkquery(props)}
                      history={this.history(props.history)}
                    />
                  )}
                </div>
              );
            }}
          />

          <Route
            path={`${ROUTE.CALENDAR.LINK}/:view/:year/:month/:date`}
            render={(props) => {
              let objDate = this.checkParam(props).objDate;
              this.checkSection(props.history);
              return (
                <div style={routerStyle}>
                  {colorTheme && (
                    <Sidebar
                      {...props}
                      {...objDate}
                      history={this.history(props.history)}
                      isSelectedToday={isSelectedToday}
                      setSelectedToday={this.setSelectedToday}
                    />
                  )}

                  {accountReducer.user.username && colorTheme && (
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        flexDirection: "column",
                        overflowX: "auto",
                      }}
                    >
                      <Calendar
                        {...props}
                        {...objDate}
                        history={this.history(props.history)}
                        settingReducer={this.props.settingReducer}
                        setSelectedToday={this.setSelectedToday}
                      />
                    </div>
                  )}
                </div>
              );
            }}
          />

          <Route
            path={ROUTE.USER_SETTING.LINK}
            render={(props) => {
              let objDate = this.checkParam(props).objDate;
              this.checkSection(props.history);
              return (
                <div style={routerStyle}>
                  {colorTheme && (
                    <Sidebar
                      {...props}
                      {...objDate}
                      history={this.history(props.history)}
                    />
                  )}
                  {accountReducer.user.username && colorTheme && (
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        flexDirection: "column",
                        overflowX: "auto",
                      }}
                    >
                      <UserSetting
                        {...props}
                        history={this.history(props.history)}
                      />
                    </div>
                  )}
                </div>
              );
            }}
          />

          <Route
            exact
            path={ROUTE.LOGIN.LINK}
            component={(props) => (
              <Login
                {...props}
                history={this.history(props.history)}
                checkSection={this.checkSection}
                save={this.save}
              />
            )}
          />

          <Route
            exact
            path={`${ROUTE.RESET_PASSWORD.LINK}/:token`}
            component={(props) => (
              <ResetPassword {...props} history={this.history(props.history)} />
            )}
          />

          <Route
            exact
            path={`${ROUTE.SET_PASSWORD.LINK}/:token`}
            component={(props) => (
              <ResetPassword
                location={props.location}
                history={this.history(props.history)}
                isSetPasswordPage
              />
            )}
          />

          <Route
            exact
            path={`${ROUTE.THANKYOU.LINK}/:bookingId/:status`}
            component={({ match }) => <Thankyou params={match.params} colorTheme={colorTheme} />}
          />

          {/* TODO: change later, when merging with an active meeting. this mock */}
          <Route
            exact
            path={`/meeting-info/:bookingId`}
            render={(props) => {
              let objDate = this.checkParam(props).objDate;
              this.checkSection(props.history);
              return (
                <div style={routerStyle}>
                  {colorTheme && (
                    <Sidebar
                      {...props}
                      {...objDate}
                      history={this.history(props.history)}
                      isSelectedToday={isSelectedToday}
                      setSelectedToday={this.setSelectedToday}
                    />
                  )}

                  {accountReducer.user.username && colorTheme && (
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        flexDirection: "column",
                        overflowX: "auto",
                      }}
                    >
                      <BookingDetail
                        history={this.history(props.history)}
                        bookingId={props.match.params}
                      />
                    </div>
                  )}
                </div>
              );
            }}
          />

          {this.redirectPageBlank()}
           
        </Switch>
      </BrowserRouter>
    );
  }
}

export const mapStateToProps = ({ accountReducer, settingReducer }) => {
  return {
    accountReducer,
    settingReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    accountAction: bindActionCreators(ACCOUNT.action, dispatch),
    settingAction: bindActionCreators(SETTING.action, dispatch),
  };
};

export default connect(
  mapStateToProps,
  (dispatch) => mapDispatchToProps(dispatch)
)(RouterPage)
